import styled from "styled-components";
import { MainInner } from "@/styles/global";
import { FondCardPadding } from "@/styles/typography";

const AllocationWrapper = styled(MainInner)`
    ${FondCardPadding}
`;

const AllocationBarWrapper = styled.div`
  max-width: 300px;
  margin: 0 auto;
  margin-top: 20px;
  height: auto;

  #allocationCircle {
    width: 100%;
  }
`;

const MSStyleBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 15px;
  margin-bottom: 15px;

  svg {
    height: auto;
    width: 80%;
    max-width: 190px;
  }

  .custom-stylebox rect[fill="#000000"] {
    fill: #001E63!important;
  }
`;

const MSStyleBoxHeader = styled.p`
  font-family: Arial, sans-serif;
  font-size: 12px;
  font-weight: 700;
  margin: 0 auto;
  margin-top: 20px;
  text-align: center;
  margin-bottom: -5px;
`;

const S = {
  AllocationWrapper,
  AllocationBarWrapper,
  MSStyleBox,
  MSStyleBoxHeader
};

export default S;
